import { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import WidgetsOutlinedIcon from "@mui/icons-material/WidgetsOutlined";
import { appConfigServices } from "../services/AppConfigServices";
import { handleApiErrorResponses } from "../utils/ApisErrorHandling";
import { toast } from "react-toastify";

const validationSchema = Yup.object({
  pipeline: Yup.string().trim().required("Pipeline is required"),
  baseUrl: Yup.string().trim().required("Base URL is required"),
});

const AiConfigurations = () => {
  const [initialValues, setInitialValues] = useState(null);
  const [loading, setLoading] = useState(true);

  const getAiConfiguration = async () => {
    try {
      setLoading(true);
      const res = await appConfigServices.getAiConfiguraion();
      console.log("ai config res:", res?.data);
      setInitialValues(res?.data?.configurations?.[0] || null);
    } catch (error) {
      handleApiErrorResponses(error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const data = {
        pipeline: values?.pipeline,
        baseUrl: values?.baseUrl,
      };
      const res = await appConfigServices.updateAiConfiguration(data);

      toast.success(res?.data?.message);
    } catch (error) {
      handleApiErrorResponses(error);
    } finally {
      setSubmitting(false);
    }
  };
  useEffect(() => {
    getAiConfiguration();
  }, []);

  return (
    <div className="p-[32px] mt-[92px] w-full overflow-hidden">
      <span className="path_line">
        <WidgetsOutlinedIcon style={{ height: "24px" }} /> &nbsp; &nbsp;/ &nbsp;
        &nbsp; AI Configurations
      </span>
      <div className="heading">AI Configurations</div>

      <div style={{ border: "1px solid #E7E7E7", margin: "24px 0" }} />

      <div
        style={{ border: "1px solid #E4E4E4" }}
        className="p-6 rounded-[16px]"
      >
        {loading && <div className="text-sm text-gray-500">Loading...</div>}

        {!loading && !initialValues && (
          <div className="text-sm text-gray-500">No configuration found.</div>
        )}

        {!loading && initialValues && (
          <Formik
            initialValues={initialValues}
            enableReinitialize
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting, errors, touched }) => (
              <Form className="space-y-5 max-w-md" noValidate>
                <div>
                  <label
                    htmlFor="pipeline"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Pipeline
                  </label>
                  <Field
                    id="pipeline"
                    name="pipeline"
                    type="text"
                    placeholder="e.g. test-pipeline"
                    className={`w-full rounded-md border border-solid px-3 py-2 text-sm text-gray-900 outline-none transition focus:ring-2 focus:ring-gray-400 ${
                      errors.pipeline && touched.pipeline
                        ? "border-red-400"
                        : "border-gray-300"
                    }`}
                  />
                  <ErrorMessage
                    name="pipeline"
                    component="p"
                    className="mt-1 text-xs text-red-500"
                  />
                </div>

                <div>
                  <label
                    htmlFor="baseUrl"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Base URL
                  </label>
                  <Field
                    id="baseUrl"
                    name="baseUrl"
                    type="text"
                    placeholder="https://example.com"
                    className={`w-full rounded-md border border-solid px-3 py-2 text-sm text-gray-900 outline-none transition focus:ring-2 focus:ring-gray-400 ${
                      errors.baseUrl && touched.baseUrl
                        ? "border-red-400"
                        : "border-gray-300"
                    }`}
                  />
                  <ErrorMessage
                    name="baseUrl"
                    component="p"
                    className="mt-1 text-xs text-red-500"
                  />
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className=" bg-[#017C57] text-white text-sm font-medium  border-none px-5 py-2.5 hover:bg-[#01553c] transition disabled:opacity-50 rounded-full"
                >
                  SAVE CHANGES
                </button>
              </Form>
            )}
          </Formik>
        )}
      </div>
    </div>
  );
};

export default AiConfigurations;
